module.exports = __webpack_public_path__ + "static/img/guowei.8cde796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/guowei.png
// module id = CdgN
// module chunks = 4